'use strict';

function emailLogsCtrl($scope, $state) {

  $scope.tabData = [
    {
      heading: 'Email Logs',
      route: 'main.user.emailLogs.emailLogsList',
      key: 'emails',
      params: {
        status: '',
        cursor: null,
        filter: null,
        query: null,
        type: null
      }
    }
  ];

  function initialize() {
    if (!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    }
    else {
      $scope.searchText = '';
    }

    $scope.searchPlaceholder = 'Search Email';
    $scope.searchState = 'main.user.emailLogs.emailLogsList';
    $scope.parentState = 'main.user.emailLogs.emailLogsList';
    $scope.parentStateParams = $state.params;
  }

  $scope.columns = [
    {id: 'receiver_email', label: 'Receiver Email'},
    {id: 'subject', label: 'Subject'},
    {id: 'created_at', label: 'Email sent', unsearchable: true},
    {id: 'updated_at', label: 'Email updated', unsearchable: true},
    {id: 'status', label: 'Status', unsearchable: true}
  ];

  initialize();

  $scope.$emit('pageTitleChanged', 'Email Logs');
}

emailLogsCtrl.$inject = ['$scope', '$state'];

angular.module('metabuyer')
  .controller('emailLogsCtrl', emailLogsCtrl);
